<template>
    <v-dialog :value="dialog" width="95%">
        <v-card>
            <v-card-title
                    class="blue-grey darken-1 py-4 title"
            >
                Stoelen selecteren
            </v-card-title>
            <seat-selection
                    :selectedTribune="selectedTribune"
                    :selectedTribuneKey="selectedTribuneKey"
                    :reservedSeats="reservedSeats"
                    :tickets="tickets"
                    v-on:seatsSelected="(newTicketsWithSeats) => { setTicketsWithSeats(newTicketsWithSeats)}"
            ></seat-selection>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="closeDialog">Cancel</v-btn>
                <v-btn flat dark @click="buyTickets">Tickets kopen</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import tribunes from "../tribunes";
import { _ } from "vue-underscore";
import SeatSelection from "./SeatSelection";
export default {
  name: "SeatSelectionDialog",
  components: { SeatSelection },
  props: {
    dialog: Boolean,
    selectedTribune: Object,
    selectedTribuneKey: String,
    tribuneSeats: Object,
    tickets: Object,
    reservedSeats: Array
  },
  data() {
    return {
      selectedSeats: [],
      selecting: true,
      ticketsWithSeats: null
    };
  },
  computed: {
    numberOfSeats: function () {
      let totalSeats = 0;
      if (this.tickets) {
        Object.keys(this.tickets).forEach(key => {
          totalSeats = totalSeats + this.tickets[key];
        });
      }

      return totalSeats;
    },
  },
  methods: {
    closeDialog: function() {
      this.$emit("closeDialog", true);
      this.resetSeatSelection();
    },
    resetSeatSelection: function() {
      this.selectedSeats = [];
      this.selecting = true;
      this.ticketsWithSeats = null;
    },
    selectCells: function(rownr, seat) {
      const availableSeats = _.difference(
        tribunes[this.selectedTribune.block].seats,
        this.reservedSeats
      );
      console.log(availableSeats);
      const index = availableSeats.indexOf(seat);
      const selectedSeats = [];
      const numberOfSeats = this.numberOfSeats;
      for (let i = 0; i < numberOfSeats; i++) {
        selectedSeats.push(availableSeats[index + i]);
      }
      this.selectedSeats = selectedSeats;
    },
    calculateSelectedSeats: function() {
      const selectedSeats = [];
      for (let i = 0; i < this.selectedSeats.length; i++) {
        const seat = this.selectedSeats[i];
        for (let j = 0; j < this.tribuneSeats.rows.length; j++) {
          const row = this.tribuneSeats.rows[j];
          if (row.items.includes(seat)) {
            selectedSeats.push({
              row: row.name,
              seat: seat
            });
          }
        }
      }

      return selectedSeats;
    },
    setTicketsWithSeats: function(tickets) {
      this.ticketsWithSeats = tickets;
    },
    buyTickets: function() {
      this.$emit("buyTickets", this.ticketsWithSeats);
      this.resetSeatSelection();
    }
  }
};
</script>
<style scoped>
th,
td {
  border: 1px solid #ccc;
  width: 50px;
  height: 30px;
  text-align: center;
  font-size: small;
}
td.stairs {
  background-image: repeating-linear-gradient(
    0deg,
    rgba(255, 255, 255, 0.6) 0px,
    rgba(255, 255, 255, 0.5) 3px,
    transparent 5px,
    transparent 10px
  );
}

td.reserved {
  background-color: red;
}
td.selected {
  background-color: green;
  cursor: pointer;
}
td.reserved:hover {
  background-color: red;
  cursor: not-allowed;
}
td.stairs:hover,
td.empty:hover {
  background-color: transparent;
  cursor: not-allowed;
}
</style>
